// useBootstrapRefreshState.ts
import { useQuery, useQueryClient } from '@tanstack/react-query'
import type { BootstrapRefreshState } from 'types'
import { BOOTSTRAP_REFRESH_STATE_KEY } from './useAllItemsBootstrap'

const DEFAULT: BootstrapRefreshState = {
  isRefreshing: false,
  startedAt: null,
  finishedAt: null,
  reason: 'unknown',
}

export function useBootstrapRefreshState() {
  const qc = useQueryClient()

  return useQuery<BootstrapRefreshState>({
    queryKey: BOOTSTRAP_REFRESH_STATE_KEY,
    queryFn: async () => qc.getQueryData<BootstrapRefreshState>(BOOTSTRAP_REFRESH_STATE_KEY) ?? DEFAULT,
    initialData: () => qc.getQueryData<BootstrapRefreshState>(BOOTSTRAP_REFRESH_STATE_KEY) ?? DEFAULT,
    staleTime: Infinity,
  })
}
